var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{class:{ 'img-mod': _vm.moderation },attrs:{"src":_vm.url},on:{"load":_vm.load,"click":function($event){return _vm.$modal.show('image-modal', { image: _vm.url })}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }